import { RootState } from "store";

export const getStateFavorites = (state: RootState) => state.favorites;
export const getFavoritesList = (state: RootState) => state.favorites.list;
export const getFavoritesError = (state: RootState) => state.favorites.error;

export const getFavoritesExceptions = (state: RootState) =>
  state.favorites.exceptions;
